@import '~tippy.js/dist/tippy.css';

:host {
  display: inline-block;
}

.o2-tooltip {
  display: inline-block;
  @include font-weight(400);
}

.tippy-box {
  border-radius: var(--border-radius, #{$border-radius});
  display: inline-block;

  .tippy-content {
    font-size: 1.4rem;
    line-height: 2rem;
    letter-spacing: 0.025rem;
    padding: 1.6rem;
    color: white;
    text-align: left;

    a {
      @include font-weight(600);
      color: white;
      text-decoration: underline rgba(255, 255, 255, 0.6);
      transition: 200ms var(--o2-transition);

      &:hover {
        text-decoration-color: rgba(255, 255, 255, 0.9);
      }
    }
  }
}

.o2-tooltip--inside-field .tippy-box {
  width: 32.8rem;
}

.o2-tooltip--default,
.o2-tooltip--brand {
  .tippy-box {
    background-color: var(--o2-blue-brand, #{$blue-brand});
  }

  .tippy-arrow {
    color: var(--o2-blue-brand, #{$blue-brand});
  }
}

.o2-tooltip--success {
  .tippy-box {
    background-color: var(--o2-green, #{$green});
  }

  .tippy-arrow {
    color: var(--o2-green, #{$green});
  }
}

.o2-tooltip--warning {
  .tippy-box {
    background-color: var(--o2-orange, #{$orange});
  }

  .tippy-arrow {
    color: var(--o2-orange, #{$orange});
  }
}

.o2-tooltip--error,
.o2-tooltip--danger {
  .tippy-box {
    background-color: var(--o2-red, #{$red});
  }

  .tippy-arrow {
    color: var(--o2-red, #{$red});
  }
}

.tippy-box[data-animation='o2-tooltip'][data-state='hidden'] {
  opacity: 0;
  transform: translateY(-2rem);
}

.tippy-box[data-inertia][data-state='visible'] {
  transition-timing-function: var(--o2-transition);
}

.o2-tooltip__root {
  position: absolute;
  display: inline-block;
  cursor: default;

  > div {
    width: max-content;
  }
}
